<form class="m-t-20" [formGroup]="form" (submit)="submit()">
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>
          <span class="label-content">First Name</span>

          <input class="form-control" type="text" name="firstname" maxlength="255" placeholder="" formControlName="firstName" />
          <cx-form-errors [control]="form.get('firstName')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>
          <span class="label-content">Last Name</span>

          <input class="form-control" type="text" name="lastName" maxlength="255" placeholder="" formControlName="lastName" />
          <cx-form-errors [control]="form.get('lastName')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>
          <span class="label-content">Email</span>
          <input class="form-control" type="text" name="email" maxlength="255" placeholder="" formControlName="email" />
          <cx-form-errors [control]="form.get('email')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="container-phone-number">
        <div class="form-group">
          <label>
            <span class="label-content">Phone Number</span>
            <input
              class="form-control"
              type="text"
              name="phoneNumber"
              maxlength="40"
              placeholder=""
              formControlName="phoneNumber"
              (keypress)="validateInput($event)"
              />
              <cx-form-errors [control]="form.get('phoneNumber')"></cx-form-errors>
            </label>
          </div>

          <div class="form-group">
            <label>
              <span class="label-content">Extension</span>

              <input class="form-control" type="text" name="extension" maxlength="40" placeholder="..." formControlName="extension" />
              <cx-form-errors [control]="form.get('extension')"></cx-form-errors>
            </label>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label>
            <span class="label-content">Company Name</span>
            <input class="form-control" type="text" name="companyName" maxlength="255" placeholder="" formControlName="companyName" />
            <cx-form-errors [control]="form.get('companyName')"></cx-form-errors>
          </label>
        </div>
      </div>

      @if (form.get('modelNumber')) {
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label>
              <span class="label-content">Model Number</span>
              <input class="form-control" type="text" name="modelNumber" maxlength="255" placeholder="" formControlName="modelNumber" />
              <cx-form-errors [control]="form.get('modelNumber')"></cx-form-errors>
            </label>
          </div>
        </div>
      }

      @if (businessTypes$ | async; as businessTypes) {
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label>
              <span class="label-content"> Business Type </span>
              <select class="form-control" formControlName="businessType">
                <option value="" disabled selected>{{ 'generic.selectAnOption' | cxTranslate }}</option>
                @for (item of businessTypes; track item) {
                  <option [attr.aria-label]="item.label" value="{{ item.code }}">
                    {{ item.label }}
                  </option>
                }
              </select>
              <cx-form-errors [control]="form.get('businessType')"></cx-form-errors>
            </label>
          </div>
        </div>
      }

      <div class="col-12 col-md-6">
        <countries-dropdown
          [isocode]="country?.isocode"
          [countries$]="countries$"
          (_onSelectCountry)="setCountry($event)"
          [form]="form"
        ></countries-dropdown>
      </div>

      <div class="col-12 col-md-6">
        @if (stateRegions$ | async; as stateRegions) {
          <div class="form-group">
            <label>
              <span class="label-content"> State/Region </span>
              <select class="form-control" formControlName="region">
                <option value="" disabled selected>{{ 'generic.selectAnOption' | cxTranslate }}</option>
                @for (item of stateRegions; track item) {
                  <option [attr.aria-label]="item.label" value="{{ item.code }}">
                    {{ item.label }}
                  </option>
                }
              </select>
              <cx-form-errors [control]="form.get('region')"></cx-form-errors>
            </label>
          </div>
        }
      </div>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label>
            <span class="label-content">City</span>

            <input class="form-control" type="text" name="city" maxlength="255" placeholder="" formControlName="city" />
            <cx-form-errors [control]="form.get('city')"></cx-form-errors>
          </label>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label>
            <span class="label-content">Zip</span>

            <input class="form-control" type="text" name="zipCode" maxlength="10" placeholder="" formControlName="zipCode" />
            <cx-form-errors [control]="form.get('zipCode')"></cx-form-errors>
          </label>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label>
            <span class="label-content">Please share more information about your request</span>
            <textarea class="form-control" [maxLength]="255" rows="3" name="info" formControlName="info" [placeholder]=""></textarea>
            <cx-form-errors [control]="form.get('info')"></cx-form-errors>
          </label>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <div class="form-check">
            <label>
              <input type="checkbox" name="optIn" formControlName="optIn" />
              <span class="form-check-label"> I would like to receive the latest updates on products and promotions </span>
              <cx-form-errors [control]="form.get('optIn')"></cx-form-errors>
            </label>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <div class="form-check f-wrap-wrap">
            <label class="w-100">
              <input type="checkbox" name="agreeWithPolicy" formControlName="agreeWithPolicy" />

              <span class="form-check-label"> I agree to the <a href="/terms-of-use" target="_blank">Privacy Policy</a>. </span>
            </label>

            <div class="w-100">
              <cx-form-errors [control]="form.get('agreeWithPolicy')"></cx-form-errors>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <button class="btn btn-primary">{{ 'generic.submit' | cxTranslate }}</button>
    </div>
  </form>